export const APP_BAR_TOOLBAR_MIN_HEIGHT = {
  xs: 48,
  sm: 56,
  lg: 52,
  xl: 60,
  xxl: 72,
  xxxl: 80,
} as const;

/** Touch-friendly drawer nav (phones + tablets below desktop). */
export const DRAWER_NAV_MENU_BUTTON_PX = { xs: 56, sm: 64, md: 72 } as const;
export const DRAWER_NAV_MENU_ICON_PX = { xs: 32, sm: 40, md: 44 } as const;
export const DRAWER_NAV_PANEL_WIDTH_PX = { xs: 300, sm: 380, md: 420 } as const;
export const DRAWER_NAV_ITEM_FONT_SIZE = {
  xs: '1.125rem',
  sm: '1.375rem',
  md: '1.5rem',
} as const;
export const DRAWER_NAV_ITEM_ICON_PX = { xs: 28, sm: 36, md: 40 } as const;
export const DRAWER_NAV_ITEM_ICON_MIN_WIDTH = { xs: 52, sm: 64, md: 72 } as const;
export const DRAWER_NAV_ITEM_PY = { xs: 1.5, sm: 2, md: 2.25 } as const;
export const DRAWER_NAV_ITEM_MIN_HEIGHT = { xs: 48, sm: 56, md: 60 } as const;
export const DRAWER_NAV_LOGO_HEIGHT_PX = { xs: 36, sm: 44, md: 48 } as const;
export const DRAWER_NAV_BADGE_SIZE_PX = { xs: 22, sm: 26, md: 30 } as const;
export const DRAWER_NAV_BADGE_FONT_SIZE = {
  xs: '0.8125rem',
  sm: '0.9375rem',
  md: '1rem',
} as const;
export const DRAWER_NAV_BADGE_OFFSET = { xs: 6, sm: 8, md: 10 } as const;

/** @deprecated Use {@link DRAWER_NAV_MENU_BUTTON_PX}. */
export const MOBILE_TOOLBAR_SIDE_WIDTH = DRAWER_NAV_MENU_BUTTON_PX.xs;

/**
 * Marker for App `<main>` scroll lock via `:has([data-app-page-fill])`.
 * Spread on the root of every fill-height trainer / board page.
 */
export const APP_PAGE_FILL_ATTR = {
  'data-app-page-fill': '',
} as const;

/**
 * Fill `<main>` below the app bar (avoid `100vh` math). Pair with
 * {@link APP_PAGE_FILL_ATTR} so main cannot scroll while this shell is mounted.
 */
export const appPageFillSx = {
  width: '100%',
  height: '100%',
  maxHeight: '100%',
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  overflow: 'hidden',
  overscrollBehavior: 'none',
} as const;
